<template>
    
    <div class="signature-stats pwd-stats">
  
   
     <ul >
       <template v-for="( statusItem ,index) in widgetsItems['data']">
        <li @click="redirectTolistPage(3)"  class="stats-item cursor status_submited-USCIS">
            <div class="stats_cnt">
                <em> Certified</em>
                <span class="count">{{ checkProperty(statusItem ,'totalCertifiedPositions' )}}</span>                
            </div>
            <div class="stats_cnt">
                <p><strong>{{ checkProperty(statusItem ,'totalCertifiedPwdCount' )}}</strong>
                PWD</p>
            </div>
        </li> 
        <li @click="redirectTolistPage(2)" class="stats-item cursor response_to_RFE_Received">
            <div class="stats_cnt">
                <em> Advertisement Released</em>
                <span class="count">{{ checkProperty(statusItem ,'totalAdvEvidencePositions' ) }}</span>                
            </div>
            <div class="stats_cnt">
                <p><strong>{{ checkProperty(statusItem ,'totalAdvEvidencePwdCount' )}}</strong>
                PWD</p>
            </div>
        </li> 
        <li @click="redirectTolistPage(1)" class="stats-item cursor status_approved">
            <div class="stats_cnt">
                <em> Assigned to PERM</em>
                <span class="count">{{ checkProperty(statusItem ,'totalAssignedPositions' )}}</span>                
            </div>
            <div class="stats_cnt">
                <p><strong>{{ checkProperty(statusItem ,'totalAssignedPwdCount' )}}</strong> PWD</p>
            </div>
            
            
             
        </li> 
       
        <li @click="redirectTolistPage(6)" class="stats-item cursor status_created">
            <div class="stats_cnt">
                <em> Unassigned</em>
                <span class="count">{{ checkProperty(statusItem ,'totalUnAssignedPositions' )}}</span>                
            </div>
            <div class="stats_cnt">
                <p><strong>{{ checkProperty(statusItem ,'totalUnAssignedPwdCount' )}}</strong>
                PWD</p>
            </div>
        </li> 
       </template>         
       
     </ul>
     <!-- {{ widgetFilterData  }} -->
     

     
   </div>

</template>

           
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import moment from "moment";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import chartLoading from "@/views/wall/chartLoading.vue";
import DatePickerCustom from "@/views/common/_date_picker_custom.vue";
am4core.useTheme(am4themes_animated);

import NoDataFound from "@/views/common/noData.vue";
import { _ } from "core-js";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

export default {
 components: {
   DateRangePicker,
   chartLoading,
   DatePickerCustom,
   NoDataFound,
 },
 data: function () {
   return {
    chartdivId:'pendingCase-chart',
     loading: true,
     isOpenDateFilter: false,
     filterText: "",
     chartData: [],
     selected_createdDateRange: ["", ""],
     autoApply: "",
     options: {
       labels: [],
       legend: {
         position: "top",
       },
     },
     series: [],
     statusCount: 0,
     allCaseTypes: [],
     selectedCaseTypes: null,

     allCaseSubTypes: [],
     selectedCaseSubTypes: [],
     caseStatusList:[],
     loading:false,
   };
 },

 mounted() {
  
   //this.getVisaTypes();
  
   const d = new Date();
  let time = d.getTime();
   this.chartdivId ='pendingCase-chart_'+time+'';
   this.filterText = "";
   

  
 },
 created() {
   document.addEventListener("scroll", this.handleScroll);
 },
 destroyed() {
   document.removeEventListener("scroll", this.handleScroll);
 },
 methods: {
   redirectTolistPage(item){
    
    let filterData = this.widgetFilterData;
    if(filterData){
        filterData = Object.assign(filterData,{"pwdPositionTypeStatus":item});
    }else{
        let obj = {
            pwdPositionTypeStatus:item
        };
        filterData = obj
    }
    console.log(JSON.stringify(filterData))
        this.navigateToDetails(filterData ,'PWD_LIST' ,'pwdStats');
   },
   handleScroll(event) {
     this.$refs["filter_menu"].dropdownVisible = false;
     // Any code to be executed when the window is scrolled pwdPositionTypeStatus
   },
   reloaStats(seleteddates) {
     this.selected_createdDateRange["startDate"] = seleteddates.startDate;
     this.selected_createdDateRange["endDate"] = seleteddates.endDate;
     this.getStats();
   },
   clear_filter() {
     this.selectedCaseTypes = [];
     this.selectedCaseSubTypes = [];
     this.selected_createdDateRange = [];
     this.filterText = "";
     this.$refs["filter_menu"].dropdownVisible = false;
     this.getStats();
   },
   togleDateFIlter() {
     this.isOpenDateFilter = this.isOpenDateFilter ? false : true;

     // if(this.isOpenDateFilter){
     //    alert(this.isOpenDateFilter)
     //     document.addEventListener("click", ()=>{
     //         this.isOpenDateFilter =false;
     //          alert(this.isOpenDateFilter +"FROM TRIGGRED")

     //     });
     // }
   },
   generateDate(type = "Today") {
     let startDate = moment().startOf("day").format("YYYY-MM-DD");
     let endDate = moment().endOf("day").format("YYYY-MM-DD");
     this.filterText = "Today";
     if (type == "Today") {
       startDate = moment().startOf("day").format("YYYY-MM-DD");
       endDate = moment().endOf("day").format("YYYY-MM-DD");
       this.selected_createdDateRange["startDate"] = startDate;
       this.selected_createdDateRange["endDate"] = endDate;
     } else if (type == "This Week") {
       this.filterText = "This Week";
       startDate = moment().startOf("week").format("YYYY-MM-DD");
       endDate = moment().endOf("week").format("YYYY-MM-DD");
       this.selected_createdDateRange["startDate"] = startDate;
       this.selected_createdDateRange["endDate"] = endDate;
     } else if (type == "This Month") {
       this.filterText = "This Month";
       startDate = moment().startOf("month").format("YYYY-MM-DD");
       endDate = moment().endOf("month").format("YYYY-MM-DD");
       this.selected_createdDateRange["startDate"] = startDate;
       this.selected_createdDateRange["endDate"] = endDate;
     } else if (type == "Custom_date") {
       startDate = this.selected_createdDateRange["startDate"];
       endDate = this.selected_createdDateRange["endDate"];
       startDate = moment(startDate).format("YYYY-MM-DD");
       endDate = moment(endDate).format("YYYY-MM-DD");

       this.filterText = startDate + " To " + endDate;
     }

     this.isOpenDateFilter = false;

     //  this.getStats();
   },
    
  
   getVisaTypes() {
     let item = {
       matcher: {
         searchString: "",
         getWorkFlowConfig: false,
         // "petitionType":
       },
       page: 1,
       perpage: 100000,
       category: "petition_types",
       sorting: {
         path: "name",
         order: 1,
       },
     };

     this.$store.dispatch("getMasterData", item).then((response) => {
       this.allCaseTypes = response.list;
     });
   },
   changedVisaType(item) {
     this.selectedCaseTypes = item;
     this.allCaseSubTypes = [];
     this.selectedCaseSubTypes = [];
     if (_.has(this.selectedCaseTypes, "id")) {
       this.getvisa_subtypes();
     }
     //  this.getStats();
   },
   getvisa_subtypes() {
     if (this.selectedCaseTypes && _.has(this.selectedCaseTypes, "id")) {
       let item = {
         matcher: {
           searchString: "",
           petitionType: parseInt(this.selectedCaseTypes["id"]),
           getWorkFlowConfig: false,
         },
         page: 1,
         perpage: 1000,
         category: "petition_sub_types",
         sorting: {
           path: "name",
           order: 1,
         },
       };

       this.$store.dispatch("getMasterData", item).then((response) => {
         this.allCaseSubTypes = response.list;
       });
     }
   },
  
 },
 computed: {},
 props:{
    widgetFilterData:null,
   wallsLoaded:{
     type: Boolean,
     default: true
   },
   widgetsItems:null,
   widgetData:null,
    
 }
};
</script>